/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_StyleInputs */



/**
* | output |
* | --- |
* | "Caption Style..." |
*
* @param {Caption_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style = /** @type {((inputs?: Caption_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style de sous-titre...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriftenstil...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile didascalia...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль подписи...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo de subtítulo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题样式……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションスタイル...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन शैली...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo da legenda...")
	return /** @type {LocalizedString} */ ("Caption Style...")
});